import { resolveBrowserTimezone } from "../utils";
export const INITIAL_STATE = {
    step: 0,
    loading: false,
    error: null,
    workspaceId: null,
    addresses: [],
    addressDoctorsMap: {},
    selectedAddress: null,
    selectedDoctor: null,
    selectedDate: new Date(),
    slots: [],
    selectedSlot: null,
    consultationMode: "OFFLINE",
    consultationCharge: "",
    currency: "INR",
    feeAudience: "DOMESTIC",
    patientTimezone: resolveBrowserTimezone(),
    patientName: "",
    patientAge: "",
    patientEmail: "",
    patientGender: "",
    bloodGroup: "",
    patientDob: "",
    patientAddress: "",
    patientCity: "",
    patientState: "",
    patientCountry: "",
    patientZipcode: "",
    patientLandmark: "",
    countryCode: "+91",
    patientPhone: "",
    otpCode: "",
    otpSent: false,
    otpVerified: false,
    otpSending: false,
    otpVerifying: false,
    verifiedPatients: [],
    selectedPatient: null,
    useExistingPatient: false,
    patientFormTab: "new",
    userSessionPacks: [],
    availablePackages: [],
    selectedSessionPack: null,
    selectedNewPackage: null,
    bookingOptionType: null,
    showPackageExplorer: false,
    packagesLoading: false,
    arePackagesConfigured: false,
    bookingType: "ONE_TIME_APPOINTMENT",
    paymentMode: "CASH",
    packageConfigId: undefined,
    patientPackageId: undefined,
    packageAmount: undefined,
    paymentPreference: {
        onlinePaymentEnabled: false,
        nationalPaymentEnabled: false,
        interNationalPaymentEnabled: false,
    },
    paymentVerificationStatus: "idle",
    reservationId: null,
    paymentOrderId: null,
};
